module.exports = __webpack_public_path__ + "assets/img/12.1a6520d4.png";